function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 6,
  width: 14,
  height: 1.5,
  rx: 0.75,
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 6,
  width: 1.5,
  height: 1.5,
  rx: 0.75,
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 10,
  width: 1.5,
  height: 1.5,
  rx: 0.75,
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 14,
  width: 1.5,
  height: 1.5,
  rx: 0.75,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 18,
  width: 1.5,
  height: 1.5,
  rx: 0.75,
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 10,
  width: 14,
  height: 1.5,
  rx: 0.75,
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 14,
  width: 14,
  height: 1.5,
  rx: 0.75,
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 18,
  width: 14,
  height: 1.5,
  rx: 0.75,
  fill: "currentColor"
});

function SvgListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default SvgListIcon;